import { render, staticRenderFns } from "./ShotsToParDonutChart.vue?vue&type=template&id=0884e1d7&"
import script from "./ShotsToParDonutChart.vue?vue&type=script&lang=js&"
export * from "./ShotsToParDonutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports